import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
   OptionLableWrapper,
} from 'admin/views/site-designer/modules/sections/modules';

const RatioSection = ({
   options,
   value,
   name,
   onChange,
}) => {
   return (
      <div className='flex gap-4'>
         {
            options.map((option, index) => {
               const isSelected = option === value;
               return (
                  <OptionLableWrapper
                     key={ index.toString() }
                     isSelected={ isSelected }
                     title={ option.replace('_', ' ') }
                     onClick={ _ => onChange(name, option) }
                  >
                     <div
                        className={ cx({
                           'w-5 h-7 min-w-[20px] rounded flex items-start justify-center py-[2px] border-2': true,
                           'border-action': isSelected,
                           'border-secondary': !isSelected,
                        }) }
                     >
                        <div
                           className={ cx({
                              'w-3 min-w-[12px] rounded flex items-center justify-center': true,
                              'bg-action': isSelected,
                              'bg-secondary': !isSelected,
                              'h-full': 'full_screen' === option,
                              'h-[13px]': '1:1' === option,
                           }) }
                        />
                     </div>
                  </OptionLableWrapper>

               )
            })
         }
      </div>

   )
}

RatioSection.propTypes = {
   options: PropTypes.array,
   value: PropTypes.any,
   onChange: PropTypes.func,
   name: PropTypes.string,
};

export default RatioSection;
